/*
 * @Description: 
 * @Author: Mayer
 * @Date: 2022-10-19 19:14:05
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-25 14:55:58
 */
import React from "react";
import "./index.less";
import WebApi from "tools/webApi";
import { store } from "tools/store";
import intl from "react-intl-universal";

import {
  setDeliver, setProblems
} from "tools/store";
import { connect } from "react-redux";


const mapStateToProps = (state: any) => {
  return {
    deliveryFaulttype: state.defaultState.deliveryFaulttype,
    isDeliverySite: state.defaultState.isDeliverySite,
    countryActiveMcc: state.defaultState.countryActiveMcc,
    haveFaultType: state.defaultState.haveFaultType,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  setDeliver: (v: any) => {
    dispatch(setDeliver(v));
  },
  setProblems: (v: any) => {
    dispatch(setProblems(v));
  },
});
@(connect(mapStateToProps, mapDispatchToProps) as any)
class ModelPrice extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      list: [],//当前列表
      listIndex1: [],
      index1: 0,
      index2: -1,
    };
  }

  componentDidMount() {
    console.log(this.props.deliveryFaulttype);
    this.getFaultTypeList();
  }
  async getFaultTypeList() {
    let state = store.getState().defaultState;
    this.setState({
      brand: state.model.leftName,
      model: state.model.rightName,
    });
    let parm:any={ mcc: this.props.countryActiveMcc };
    //是否寄修服务 0普通 1寄修  2上门 3智能柜
    if(this.props.isDeliverySite===3){
      parm.category='rp_order_cabinet_fault_type_problem_category'
    }else if(this.props.isDeliverySite===0){
      parm.category='rp_order_fault_type_problem_category_'+this.props.countryActiveMcc
    }
    let res: any = await WebApi.deliveryFault(parm)
    // let res1: any = {
    //   "code": 200,
    //   "message": "success",
    //   "desc": "",
    //   "data": [
    //     {
    //       "deliveryFaultCategory": "2222",
    //       "deliveryFaults": [
    //         {
    //           "id": 3,
    //           "categoryId": 2,
    //           "title": "333",
    //           "subTitle": "333333",
    //           "sort": 3
    //         },
    //         {
    //           "id": 57,
    //           "categoryId": 2,
    //           "title": "214",
    //           "subTitle": "",
    //           "sort": 4
    //         }
    //       ]
    //     },
    //     {
    //       "deliveryFaultCategory": "11111",
    //       "deliveryFaults": [
    //         {
    //           "id": 2,
    //           "categoryId": 1,
    //           "title": "2222",
    //           "subTitle": "2232",
    //           "sort": 1
    //         },
    //         {
    //           "id": 1,
    //           "categoryId": 1,
    //           "title": "1111",
    //           "subTitle": "111111",
    //           "sort": 2
    //         }
    //       ]
    //     },
    //     {
    //       "deliveryFaultCategory": "4444",
    //       "deliveryFaults": [
    //         {
    //           "id": 11,
    //           "categoryId": 9,
    //           "title": "4-1",
    //           "subTitle": "副标题4-1",
    //           "sort": 1
    //         }
    //       ]
    //     },
    //     {
    //       "deliveryFaultCategory": "3333",
    //       "deliveryFaults": []
    //     }
    //   ],
    //   "timestamp": 1706670554740,
    //   "requestId": "6b30786c-4771-468e-92d8-7fa79c632846"
    // }
    if (res && +res.code === 200) {
      this.setState({
        list: res.data,
      });
      if (this.props.deliveryFaulttype.length < 1) { //"第一次"进入该页面
        if (res.data.length < 1) {
          this.setState({ index1: -1 });
          // this.props.setDeliver({ type: 8, data: [-1, -1, intl.get("add2.name13")] });
        } else {
          // this.props.setDeliver({ type: 8, data: [0, 0, res.data[0].deliveryFaults[0]] });
          this.props.setProblems('');
          this.setState({
            listIndex1: [true]
          })
        }
        // } else if (this.props.deliveryFaulttype[0] !== -1) {
        //   let a: any = [];
        //   a[this.props.deliveryFaulttype[0]] = true;
        //   this.setState({ listIndex1: a })
      } else {
        this.setState({
          index1: this.props.deliveryFaulttype[0],
          index2: this.props.deliveryFaulttype[1]
        })
      }
    }
  }
  makefault1 = () => {
    let _this = this;
    if (_this.state.index1 === -1) {
      _this.props.setDeliver({ type: 8, data: [-1, -1, intl.get("add2.name13")] });
      setTimeout(function () { _this.props.handle(); }, 20);
    } else {
      if (_this.state.index2 === -1) {
        // 不是其他，但是没选理由
        return;
      } else {
        // 不是其他，同时选择了理由
        // console.log([this.state.index1, this.state.index2, this.state.list[this.state.index1].deliveryFaults[this.state.index2]])
        _this.props.setDeliver({ type: 8, data: [_this.state.index1, _this.state.index2, _this.state.list[_this.state.index1].deliveryFaults[_this.state.index2]] });
        setTimeout(function () { _this.props.handle(); }, 20);
      }
    }
  }
  canlight = () => {
    let _this = this;
    if (_this.state.index1 > -1) {
      if (_this.state.index2 > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  render() {
    return (
      <>
        <div className="faultpctype">
          <h3>Fault Type</h3>
          <h4>Select Fault Categor</h4>
          <ul>
            {this.state.list?.length > 0 && this.state.list.map((item: any, i: number) => {
              return <li className={this.state.index1 === i ? "active" : ""} key={i} onClick={() => { this.setState({ index1: i, index2: -1 }) }}>{item.deliveryFaultCategory}</li>
            })}
            <li className={this.state.index1 === -1 ? "active" : ""} onClick={() => { this.setState({ index1: -1, index2: -1 }) }}>{intl.get("add2.name13")}</li>
          </ul>
          {this.state.list?.length > 0 && this.state.index1 > -1 ? <>
            <h4>Select Fault name:</h4>
            <ul>
              {this.state.list?.length > 0 && this.state.list[this.state.index1].deliveryFaults?.length > 0 && (this.state.list[this.state.index1].deliveryFaults||[]).map((v1: any, i1: number) => {
                return <li className={this.state.index2 === i1 ? "active" : ""} key={i1} onClick={() => { this.setState({ index2: i1 }) }}>{v1.title}</li>
              })}
            </ul></> : ''}
        </div>
        <div className="fault_btns">
          <div className="left" onClick={() => { this.props.handle(); }}>Cancel</div>
          <div className={this.canlight() ? "right" : "right light"} onClick={() => { this.makefault1() }}>Confirm</div>
        </div>
      </>
    );
  }
}

export default (ModelPrice);
